export enum GestaoPaginaEnum {
    Header = 1,
    TituloPrincipal = 2,
    Subtitulo = 3,
    BannerPrincipal = 4,
    Sobre = 5,
    Servicos = 6,
    Parceiros = 7,
    Testemunhos = 8,
    Galeria = 9,
    Eventos = 10,
    CallToAction = 11,
    Rodape = 12,
    Contactos = 13,
    RedesSociais = 14,
    Missao = 15,
    Valores = 16,
    Visao = 17,
    PropositoFundcube = 18,
    PerguntasFrequentes = 19
}